var _PageLoader;
import { createContext, useContext } from 'react';
import { Button, PageLoader } from '@crehana/compass.ui/v2';
import { FeatureFlagProvider } from '@crehana/feature-flags/react';
import { useUserPermissions } from "../hooks/use-user-permissions";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var UserSessionContext = /*#__PURE__*/createContext(null);
export function useUserSession() {
  var context = useContext(UserSessionContext);
  if (!context) {
    throw new Error('useUserSession must be used within a UserSessionProvider');
  }
  return context;
}
export function UserSessionProvider(_ref) {
  var children = _ref.children,
    targetSegment = _ref.targetSegment;
  var _useUserPermissions = useUserPermissions({}),
    me = _useUserPermissions.me,
    loading = _useUserPermissions.loading,
    refetchMe = _useUserPermissions.refetch,
    centralizedOrganizationId = _useUserPermissions.centralizedOrganizationId,
    _useUserPermissions$l = _useUserPermissions.learningOrganizationId,
    learningOrganizationId = _useUserPermissions$l === void 0 ? 0 : _useUserPermissions$l,
    slug = _useUserPermissions.slug;
  var handleRefetch = function handleRefetch() {
    targetSegment === 'end-user' && refetchMe();
  };
  var centralizedId = centralizedOrganizationId;
  if (loading) {
    return _PageLoader || (_PageLoader = /*#__PURE__*/_jsx(PageLoader, {}));
  }
  if (targetSegment === 'end-user' && !me || !me || !learningOrganizationId || learningOrganizationId === 0 || !slug) {
    return /*#__PURE__*/_jsxs("div", {
      className: "tw-flex tw-flex-col tw-items-center tw-justify-center tw-gap-1.2",
      style: {
        width: '100svw',
        height: '100svh'
      },
      children: [/*#__PURE__*/_jsx("p", {
        className: "tw-font-subtitle3 tw-text-center",
        style: {
          maxWidth: '40.0rem'
        },
        children: "Ups! An error occurred while fetching the session user data. Please try again."
      }), /*#__PURE__*/_jsx(Button, {
        type: "button",
        onClick: handleRefetch,
        children: "Retry"
      })]
    });
  }
  var value = {
    me: {
      centralized: me
    },
    organization: {
      centralizedId: centralizedId,
      learningId: learningOrganizationId,
      slug: slug
    }
  };
  return /*#__PURE__*/_jsx(UserSessionContext.Provider, {
    value: value,
    children: /*#__PURE__*/_jsx(FeatureFlagProvider, {
      organizationId: learningOrganizationId,
      children: children
    })
  });
}